export const IconDetailsQuestionMark: {
  name: 'icon_details_question_mark-3b71454dd992'
} = {
  name: 'icon_details_question_mark-3b71454dd992'
}
